import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/** The photograph runs edge to edge; the name shouts underneath it. */
export const Product: FC<ProductViewProps> = () => (
  <div>
    <PartRegion name="gallery" />
    <StorefrontContainer className="py-10">
      <div className="grid gap-12 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        <PartRegion name="main" className="min-w-0" />
      </div>
    </StorefrontContainer>
  </div>
);
